import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Button,
  LinearProgress,
  Alert,
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import axios from 'axios';

function Upload() {
  const [selectedFiles, setSelectedFiles] = useState({
    video: null,
    subtitle: null,
  });
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleFileSelect = (event, type) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFiles((prev) => ({
        ...prev,
        [type]: file,
      }));
    }
  };

  const handleUpload = async () => {
    if (!selectedFiles.video) {
      setError('Please select a video file');
      return;
    }

    setUploading(true);
    setError(null);

    const formData = new FormData();
    formData.append('video', selectedFiles.video);
    if (selectedFiles.subtitle) {
      formData.append('subtitle', selectedFiles.subtitle);
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data.success) {
        navigate(`/player/${response.data.videoId}`);
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 600, mx: 'auto', mt: 4 }}>
      <Paper elevation={3} sx={{ p: 3 }}>
        <Typography variant="h5" gutterBottom>
          Upload Media
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Box sx={{ mb: 3 }}>
          <input
            accept="video/*"
            style={{ display: 'none' }}
            id="video-file"
            type="file"
            onChange={(e) => handleFileSelect(e, 'video')}
          />
          <label htmlFor="video-file">
            <Button
              variant="contained"
              component="span"
              startIcon={<CloudUploadIcon />}
              fullWidth
            >
              Select Video
            </Button>
          </label>
          {selectedFiles.video && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected: {selectedFiles.video.name}
            </Typography>
          )}
        </Box>

        <Box sx={{ mb: 3 }}>
          <input
            accept=".srt,.vtt"
            style={{ display: 'none' }}
            id="subtitle-file"
            type="file"
            onChange={(e) => handleFileSelect(e, 'subtitle')}
          />
          <label htmlFor="subtitle-file">
            <Button
              variant="outlined"
              component="span"
              startIcon={<CloudUploadIcon />}
              fullWidth
            >
              Select Subtitle (Optional)
            </Button>
          </label>
          {selectedFiles.subtitle && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Selected: {selectedFiles.subtitle.name}
            </Typography>
          )}
        </Box>

        {uploading && <LinearProgress sx={{ mb: 2 }} />}

        <Button
          variant="contained"
          color="primary"
          onClick={handleUpload}
          disabled={uploading || !selectedFiles.video}
          fullWidth
        >
          {uploading ? 'Uploading...' : 'Upload'}
        </Button>
      </Paper>
    </Box>
  );
}

export default Upload; 